
const digest = '85b8ed303792f59736ce34d21c6e566f8a2d8b4a19d4c56e367863314b5ebc4b';
const classes = {"errorMessage":"_errorMessage_4kw0u_1","invalid":"_invalid_4kw0u_7"};
const css = `._errorMessage_4kw0u_1 {
  font-family: Poppins, sans-serif;
  font-size: 14px;
  color: red;
}

._invalid_4kw0u_7 {
  border-color: red !important;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  